<template>
    <v-list dense>
        <v-list-item
            v-for="item in items"
            :key="item.title"
            router
            :to="item.route"
            link
            theme="dark"
            v-if="can(item.permission)"
        >
            <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    name: "Menu",

    computed: {},

    data: () => ({
        items: [
            {title: 'Dashboard', icon: 'mdi-view-dashboard', route: '/', permission: 'dashboard-access'},
            {title: 'Customers', icon: 'mdi-account-group-outline', route: '/customers', permission: 'customers-access'},
            {title: 'Appointments', icon: 'mdi-timetable', route: '/appointments', permission: 'appointments-access'},
            {title: 'Biographies', icon: 'fa-address-card', route: '/biographies', permission: 'biographies-access'},
            {title: 'Invoicing', icon: 'fa-file-invoice-dollar', route: '/invoicing', permission: 'invoicing-access'},
            {title: 'Statistics', icon: 'mdi-chart-areaspline', route: '/login', permission: 'statistics-access'},
            {title: 'Employees', icon: 'mdi-account-settings', route: '/users', permission: 'employees-access'},
            {title: 'Your account', icon: 'mdi-settings', route: '/profile', permission: 'account-access'},
            {title: 'Magazine', icon: 'mdi-library-books', route: 'magazine', permission: 'magazine-access'},
            {title: 'Insider', icon: 'mdi-information-outline', route: '/insider', permission: 'insider-access'}
        ],
    }),


};
</script>
